// https://en.wikipedia.org/wiki/ISO_8601#Durations

export const duration = millisecond => {
  let temp = millisecond / 1000 | 0
  const seconds = temp % 60
  temp = (temp - seconds) / 60
  const minutes = temp % 60
  temp = (temp - minutes) / 60
  const hours = temp % 24
  temp = (temp - hours) / 24
  const days = temp % 30
  temp = (temp - days) / 30
  const months = temp % 12
  const years = (temp - months) / 12
  const Y = years > 0 ? `${years}Y` : ''
  const M = months > 0 ? `${months}M` : ''
  const D = days > 0 ? `${days}D` : ''
  const H = hours > 0 ? `${hours}H` : ''
  const M2 = minutes > 0 ? `${minutes}M` : ''
  const S = seconds > 0 ? `${seconds}S` : ''
  return `P${Y + M + D}T${H + M2 + S}`
}

// 严格区分大写和小写
// H: 0-23 h: am/pm 1-12
const generateSet = date => ({
  y: date.getFullYear(),
  M: date.getMonth() + 1,
  d: date.getDate(),
  H: date.getHours(),
  m: date.getMinutes(),
  s: date.getSeconds()
})

const padZero = (num, digits) => {
  const numDigits = String(num).length
  if (digits <= numDigits) {
    return num
  }
  return num < Math.pow(10, digits - 1) ? '0'.repeat(digits - numDigits) + num : num
}

export const formatDate = (d, fmt) => {
  const reg = /(y|M|d|H|m|s)+/g
  const date = new Date(d)
  const set = generateSet(date)
  let res
  while ((res = reg.exec(fmt)) !== null) {
    // console.log(res)
    fmt = fmt.replace(res[0], padZero(set[res[1]], res[0].length))
  }
  return fmt
}

// 计时器支持 天 小时 分钟 秒 不支持月 年等
const regs = [/d+/, /h+/, /m+/, /s+/]
const intervals = { 'd': 60 * 60 * 24, 'h': 60 * 60, 'm': 60, 's': 0 }
const genSecondsSet = () => {
  const res = {}
  const fn = (seconds, interval) => {
    if (interval === 0) return [seconds, 0]
    const s = seconds % interval
    const remained = (seconds - s) / interval
    return [remained, s]
  }
  Object.entries(intervals).forEach(([key, interval]) => {
    res[key] = seconds => fn(seconds, interval)
  })
  return res
}
/**
 * @param { number } seconds
 */
export const formatTimer = (seconds, fmt) => {
  let temp = seconds
  const set = genSecondsSet()
  regs.forEach(it => {
    const res = fmt.match(it)
    if (res !== null) {
      const [r, s] = set[res[0].charAt(0)](temp)
      fmt = fmt.replace(res[0], padZero(r, res[0].length))
      temp = s
    }
  })
  return fmt
}
